import React, { useState } from 'react';
import { HiBriefcase, HiCurrencyRupee, HiLocationMarker } from 'react-icons/hi';
import { Img } from 'react-image';
import { UIExtendedApplication } from 'types';
interface Props {
	application: UIExtendedApplication;
}
const PositionDetails = ({ application }: Props) => {
	const [showRecommendationInfo, setShowRecommendationInfo] = useState(false);
	const minSalary = application.position?.salary.min;
	const maxSalary = application.position?.salary.max;
	const location = application.position?.workLocations;
	const locationArray = Array.isArray(location) ? location : location ? [location] : [];
	const workLocation = application.position?.workLocation;
	if (workLocation && !locationArray.includes(workLocation)) {
		locationArray.push(workLocation);
	}
	const locationString = locationArray.join(' | ');
	const type = application.position?.positionType;
	const workingMode = application.position?.workingMode;
	const showInterestedProfileNote = (application as any)?.recommendationTypes?.includes('you_might_be_interested');
	const workingExp = application.position?.positionRequirement.workExperience
		? application.position?.positionRequirement.workExperience.min === 0 &&
			application.position?.positionRequirement.workExperience.max === 0
			? 'Fresher'
			: `${Math.floor(application.position?.positionRequirement.workExperience.min)} Yrs ${Math.ceil(application.position?.positionRequirement.workExperience?.min * 12) % 12
			} Mon - ${Math.floor(application.position?.positionRequirement.workExperience.max)} Yrs ${Math.ceil(application.position?.positionRequirement.workExperience?.max * 12) % 12
			} Mon `
		: '';
	return (
		<div className="mt-[8px]">
			<div className="mt-2 flex flex-wrap gap-4">
				<div className="flex items-center text-sm font-medium dark:text-[#FAFAFC] text-black">
					<HiBriefcase className="text-[#00B7C4] dark:text-[#A9EFF2] w-[20px] h-[20px]" />
					<div className="ml-1 gap-1 flex">
						{workingMode === 'FullTime'
							? 'Full-Time'
							: workingMode === 'InternshipToFullTime'
								? 'Internship + Full-Time'
								: workingMode}
						<Img className="ml-1 inline-block object-contain" src="/assets/dot.svg" alt="currency" width={6} height={6} />
						<span className="ml-1">{workingExp}</span>
					</div>
				</div>

				<div className="text-sm font-medium dark:text-[#FAFAFC] text-black">
					<span className="mr-1 inline-block align-middle">
						<HiCurrencyRupee className="text-[#00B7C4] dark:text-[#A9EFF2] w-[20px] h-[20px]" />
					</span>
					{minSalary} - {maxSalary} LPA
				</div>
				<div className="text-sm font-medium dark:text-[#FAFAFC] text-black">
					<span className="mr-1 inline-block align-middle">
						<HiLocationMarker className="text-[#00B7C4] dark:text-[#A9EFF2] w-[16px] h-[16px]" />
					</span>
					{locationString}
					<span className="mx-1 inline-block h-2 align-middle">
						<Img src="/assets/dot.svg" alt="dot" width={6} height={6} />
					</span>
					{type}
				</div>
			</div>
			{showInterestedProfileNote ? (
				<div className="mt-3 rounded-lg border border-[#C7D2FE] bg-[#EEF2FF] px-3 py-2">
					<button
						type="button"
						onClick={event => {
							// Prevent card click handlers from opening the main drawer.
							event.preventDefault();
							event.stopPropagation();
							setShowRecommendationInfo(prev => !prev);
						}}
						className="flex w-full items-center justify-between text-left"
					>
						<span className="text-[13px] font-semibold text-[#3730A3]">Why this role?</span>
						<span className="rounded-full bg-[#4338CA] px-2 py-[2px] text-[10px] font-semibold uppercase tracking-wide text-white">
							{showRecommendationInfo ? 'Hide' : 'Tap to read'}
						</span>
					</button>
					<div
						className={`overflow-hidden transition-all duration-300 ease-in-out ${showRecommendationInfo ? 'max-h-40 opacity-100 mt-2' : 'max-h-0 opacity-0'
							}`}
					>
						<p className="text-[13px] leading-[20px] text-[#312E81]">
							We are recommending this role based on your prior experience and skill set. If you feel these opportunities
							do not align with what you studied at Masai School, you may choose to ignore these recommendations.
						</p>
					</div>
				</div>
			) : null}
		</div>
	);
};

export default PositionDetails;
